import { render } from "./IconLeaf.vue?vue&type=template&id=34879d57"
import script from "./IconLeaf.vue?vue&type=script&lang=ts"
export * from "./IconLeaf.vue?vue&type=script&lang=ts"
script.render = render

export default script